import { isDevelopment, COLOR_WHEEL_TOOL } from '@quicktools/shared-components';

export const isDev = isDevelopment();
export { isMobile } from 'react-device-detect';

export const BASE_URL = `${process.env.NX_DEPLOY_PATH}${process.env.NX_DEPLOY_SUFFIX}`;
export const VERSION = process.env.NX_APP_VERSION;

export const TOOL_NAME = COLOR_WHEEL_TOOL.id;

export const TRACKING_ID = process.env.NX_TRACKING_ID;
export const TRACKING_ID_4 = process.env.NX_TRACKING_ID_4;
export const HOTJAR_ID = Number(process.env.NX_HOTJAR_ID);
export const BUGSNAG_ID = process.env.NX_BUGSNAG_ID;
export const OPTIMIZE_ID = process.env.NX_OPTIMIZE_ID;
export const ONETRUST_ID = process.env.NX_ONETRUST_ID;

export const QUICKTOOLS_API_BASE_URL = process.env.NX_QUICKTOOLS_API_BASE_URL;
